export const SUCCESS = "success";
export const FAIL = "fail";
export const NO_USER_FOUND = "No user found";
export const FAILED_AUTHENTICATE_TOKEN = "Failed to authenticate token";
export const BAD_REQUEST_400 = "Bad Request (400)";